//import dateService from '@/services/util/dateService'
//import loggingService from '@/services/util/loggingService'

// var serviceName = 'workflowUserAssignService'
// var path = '/WorkflowUserAssign/'
// var isDebug = false

const DivisionEnum = {
    Admin: { tab_id: 'tab-sm', name: 'admin' },
    SpillsManager: { tab_id: 'tab-sm', name: 'spillsManager' },
    GroundWater: { tab_id: 'tab-gw', name: 'groundWater' },
    Uranium: { tab_id: 'tab-u', name: 'uranium' },
    Air: { tab_id: 'tab-a', name: 'air' },
    WaterWastewater: { tab_id: 'tab-ww', name: 'waterWastewater' },
    SolidWaste: { tab_id: 'tab-sw', name: 'solidWaste' },
    HCBManager: { tab_id: 'tab-hcb', name: 'hcbManager' }
}

export default {
    DivisionEnum: DivisionEnum
}
